<template>
  <div class="calculations-starter-modal" v-loading="loading">
    <div class="calculations-starter-header">
      <el-button
        @click="back"
        class="calculations-starter-back-button"
        type="text"
      >
        <i class="el-icon-arrow-left" /> К списку инструментов
      </el-button>
      <div class="calculations-starter-model">
        <r-text type="caption"> Модель: {{ model.name }} </r-text>
      </div>
    </div>
    <div class="calculations-starter-content">
      <r-title type="subtitle-1" style="margin-bottom: 16px;">
        Расчеты
      </r-title>
      <div class="calculations-starter-controls">
        <el-dropdown class="r-dropdown" @command="handleClick">
          <el-button type="primary" class="r-button">
            Запустить новый расчет
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu class="r-dropdown-menu">
            <el-dropdown-item :disabled="!matrices.length" command="due">
              Расчет DUE
            </el-dropdown-item>
            <el-dropdown-item command="sta">Расчет STA</el-dropdown-item>
            <el-dropdown-item command="visum">Расчет Visum</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="calculations-startercontainer" v-if="calculations.length">
        <r-text type="caption" style="margin-bottom: 4px;">
          Существующие расчеты
        </r-text>
        <ul class="calculations-starter-list">
          <li
            class="calculations-starter-item"
            v-for="item in calculations"
            :key="item.id"
          >
            <div
              class="calculations-starter-item-header"
              @click="toggleCalc(item)"
            >
              <div class="calculations-starter-item-main">
                <div class="calculations-starter-item-name">
                  <r-text>
                    {{ item.name || "Без имени" }}
                  </r-text>
                </div>
                <div class="calculations-starter-item-type">
                  <r-text type="caption">
                    {{ item.calc_type }}
                  </r-text>
                </div>
              </div>
              <div class="calculations-starter-item-time">
                <r-text type="caption">
                  {{ getCalcTime(item) }}
                </r-text>
              </div>
              <div class="calculations-starter-item-arrow" v-if="item.result">
                <i
                  :class="
                    item.show ? 'el-icon-arrow-down' : 'el-icon-arrow-right'
                  "
                />
              </div>
            </div>
            <div
              class="calculations-starter-item-additional"
              v-if="item.show && item.result"
            >
              <div class="calculations-starter-item-row">
                <r-title type="subtitle-2">Директория</r-title>
                <div class="calculations-starter-item-value">
                  <r-text>{{ item.result.input_dir }}</r-text>
                </div>
              </div>
              <div class="calculations-starter-item-row">
                <r-title type="subtitle-2">Input Log</r-title>
                <div
                  class="calculations-starter-item-value download"
                  @click="downloadFile(item.result.log_archive_input)"
                >
                  {{ item.result.log_archive_input }}
                </div>
              </div>
              <div class="calculations-starter-item-row">
                <r-title type="subtitle-2">Output Log</r-title>
                <div
                  class="calculations-starter-item-value download"
                  @click="downloadFile(item.result.log_archive_output)"
                >
                  {{ item.result.log_archive_output }}
                </div>
              </div>
              <div class="calculations-starter-item-row">
                <r-title type="subtitle-2">Вывод консоли</r-title>
                <div class="calculations-starter-item-value text">
                  <r-text>{{ item.result.output }}</r-text>
                </div>
              </div>
              <div class="calculations-starter-item-row">
                <r-title type="subtitle-2">Действия</r-title>
                <div class="calculations-starter-item-value controls">
                  <el-button
                    size="mini"
                    class="r-button"
                    type="danger"
                    @click="deleteHandler(item.id)"
                    :loading="deletingCalc === item.id"
                  >
                    Удалить расчет
                  </el-button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="calculations-starter-nodata" v-else>
        <r-text type="caption">
          Расчеты отсутствуют
        </r-text>
      </div>
    </div>

    <el-dialog
      class="modal-window"
      :title="getCalcModalTitle()"
      :visible.sync="showParamsModal"
      :show-close="false"
      :append-to-body="true"
      width="420px"
    >
      <div class="calculations-starter-row">
        <div class="calculations-starter-block">
          <r-text type="caption" style="margin-bottom: 4px;">
            Название
          </r-text>
          <el-input class="r-input" v-model="calcName" />
        </div>
      </div>
      <div
        class="calculations-starter-due"
        v-if="calcType === 'due' || calcType === 'sta'"
      >
        <div class="calculations-starter-row">
          <div class="calculations-starter-block">
            <r-text type="caption" style="margin-bottom: 4px;">
              Матрица корреспонденций
            </r-text>
            <el-select
              class="r-select"
              v-model="matrixId"
              placeholder="Выберите матрицу"
              size="mini"
            >
              <el-option
                v-for="item in matrices"
                :key="item.id"
                :label="`№${item.no} ${item.name}`"
                :value="item.id"
              />
            </el-select>
          </div>
        </div>
        <div class="calculations-starter-row" v-if="calcType === 'due'">
          <div class="calculations-starter-block">
            <r-text type="caption" style="margin-bottom: 4px;">
              Начало моделирования
            </r-text>
            <el-input-number
              :controls="false"
              class="r-input dark"
              size="mini"
              type="number"
              v-model="calcParams.start"
            />
          </div>
          <div class="calculations-starter-block">
            <r-text type="caption" style="margin-bottom: 4px;">
              Окончание моделирования
            </r-text>
            <el-input-number
              :controls="false"
              class="r-input dark"
              size="mini"
              type="number"
              v-model="calcParams.end"
            />
          </div>
        </div>
        <div class="calculations-starter-row" v-if="calcType === 'due'">
          <div class="calculations-starter-block">
            <r-text type="caption" style="margin-bottom: 4px;">
              Шаг для DNL
            </r-text>
            <el-input-number
              :controls="false"
              class="r-input dark"
              size="mini"
              type="number"
              v-model="calcParams.step_dnl"
            />
          </div>
          <div class="calculations-starter-block">
            <r-text type="caption" style="margin-bottom: 4px;">
              Шаг для DUE
            </r-text>
            <el-input-number
              :controls="false"
              class="r-input dark"
              size="mini"
              type="number"
              v-model="calcParams.step_due"
            />
          </div>
          <div class="calculations-starter-block">
            <r-text type="caption" style="margin-bottom: 4px;">
              Шаг для МК
            </r-text>
            <el-input-number
              :controls="false"
              class="r-input dark"
              size="mini"
              type="number"
              v-model="calcParams.step_od"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="r-button simple" @click="closeModal">
          Отменить
        </el-button>
        <el-button
          class="r-button"
          type="primary"
          @click="startCalc"
          :disabled="startCalcDisabled"
          :loading="starting"
        >
          Запустить расчет
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import constants from "@/constants/url";
import { downloadFile, notifyFactory } from "@/utils";

export default {
  data() {
    return {
      loading: false,
      calculations: [],
      matrices: [],
      url: constants.URL,
      starting: false,
      showParamsModal: false,
      calcName: "",
      calcType: "",
      matrixId: null,
      deletingCalc: null,
      calcParams: {
        start: 0,
        end: 86400,
        step_dnl: 300,
        step_due: 300,
        step_od: 300
      }
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
    model() {
      return this.$store.state.scenarioModelling.model;
    },
    startCalcDisabled() {
      return this.calcType === "due"
        ? !this.calcName || !this.matrixId
        : !this.calcName;
    }
  },
  methods: {
    getCalcModalTitle() {
      return `Параметры расчета ${this.calcType.toUpperCase()}`;
    },
    toggleCalc(calc) {
      this.calculations.forEach(c => {
        if (c !== calc) this.$set(c, "show", false);
        else this.$set(c, "show", !calc.show);
      });
    },
    closeModal() {
      this.showParamsModal = false;
      this.calcName = "";
      this.matrixId = null;
    },
    startCalc() {
      switch (this.calcType) {
        case "due":
          return this.startDue();
        case "sta":
          return this.startSta();
        case "visum":
          return this.startVisum();
      }
    },
    back() {
      this.$store.commit("SET_SM_STATE_PROP", {
        name: "view",
        value: "mode-select"
      });
    },
    handleClick(type) {
      this.calcType = type;
      this.showParamsModal = true;
    },
    async startSta() {
      try {
        const data = new FormData();
        const source_id = this.model.id;

        data.append("source_id", source_id);
        data.append("matrix_id", this.matrixId);
        data.append("name", this.calcName);

        await this.$store.dispatch("SEND_FORM_DATA", {
          url: `worker/StaProcess`,
          data
        });

        const title = "Расчет STA";
        const message = "Расчет успешно запущен";
        this.$notify(notifyFactory("success", title, message));
        setTimeout(() => {
          this.starting = false;
          this.closeModal();
          this.getCalculations();
        }, 1000);
      } catch (error) {
        console.log(error);
        this.starting = false;
      }
    },
    async startDue() {
      try {
        const data = new FormData();
        const source_id = this.model.id;
        const { start, end, step_dnl, step_due, step_od } = this.calcParams;
        const calc_params = {
          start,
          end,
          step_dnl,
          step_due,
          step_od
        };

        data.append("source_id", source_id);
        data.append("matrix_id", this.matrixId);
        data.append("calc_params", JSON.stringify(calc_params));
        data.append("name", this.calcName);

        await this.$store.dispatch("SEND_FORM_DATA", {
          url: `worker/DueProcess`,
          data
        });

        const title = "Расчет DUE";
        const message = "Расчет успешно запущен";
        this.$notify(notifyFactory("success", title, message));
        setTimeout(() => {
          this.starting = false;
          this.closeModal();
          this.getCalculations();
        }, 1000);
      } catch (error) {
        console.log(error);
        this.starting = false;
      }
    },
    async startVisum() {
      try {
        this.starting = true;
        const data = new FormData();
        const source_id = this.model.id;

        data.append("source_id", source_id);
        data.append("name", this.calcName);

        const resultData = await this.$store.dispatch("SEND_FORM_DATA", {
          url: `worker/VisumProcess`,
          data
        });

        const title = "Расчет Visum";
        const message = "Расчет успешно запущен";
        this.$notify(notifyFactory("success", title, message));
        setTimeout(() => {
          this.starting = false;
          this.closeModal();
          this.getCalculations();
        }, 1000);
        console.log("task_id --- ", resultData.data.task_id);
      } catch (error) {
        console.log(error);
        this.starting = false;
      }
    },
    deleteHandler(deletingId) {
      const warningText = "Расчет будет удален. Продолжить?";
      const warningTitle = "Удаление расчета";
      const confirmButtonText = "Да";
      const cancelButtonText = "Отменить";

      this.$confirm(warningText, warningTitle, {
        customClass: "r-message-box",
        type: "warning",
        closeOnPressEscape: false,
        closeOnClickModal: false,
        confirmButtonText,
        cancelButtonText
      })
        .then(() => {
          this.deleteCalc(deletingId);
        })
        .catch(() => {});
    },
    async deleteCalc(deletingId) {
      try {
        this.deletingCalc = deletingId;
        const { ids } = this.model;
        const id = ids["calculations"];
        const url = `objectInfo/${id}?id=${deletingId}`;

        await this.$store.dispatch("DELETE_REQUEST", { url });
        await this.getCalculations();
        const title = "Расчет удален";
        const message = "Расчет успешно удален";
        this.$notify(notifyFactory("success", title, message));
        this.deletingCalc = null;
      } catch (error) {
        console.log(error);
        this.deletingCalc = null;
      }
    },
    getCalcTime({ start_time, end_time }) {
      if (!end_time) return "В процессе...";

      return `${this.parseTime(start_time)} - ${this.parseTime(end_time)}`;
    },
    parseTime(time) {
      return moment(time).format("YYYY/MM/DD HH:mm:ss");
    },
    downloadFile(item) {
      const file = {
        href: `${this.url}/download_share_resource/${item}?access_token=${
          this.token
        }`,
        name: "download"
      };

      downloadFile(file);
    },
    async getCalculations() {
      try {
        const { ids } = this.model;
        const id = ids["calculations"];
        const url = `objectInfo/${id}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });

        this.calculations = Object.values(data).map(c => ({
          ...c,
          show: false
        }));
      } catch (error) {
        console.log(error);
      }
    },
    async getMatrices() {
      try {
        const { ids } = this.model;
        const id = ids["matrices"];
        const url = `objectInfo/${id}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });

        this.matrices = Object.values(data);
      } catch (error) {
        console.log(error);
      }
    }
  },
  async created() {
    this.loading = true;

    await this.getMatrices();
    await this.getCalculations();

    this.loading = false;
  }
};
</script>

<style lang="scss">
.calculations-starter {
  &-modal {
    width: 540px;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    .el-button {
      padding: 0;
      font-size: 12px;
    }
  }

  &-controls {
    display: flex;
    justify-content: flex-end;
  }

  &-container {
    margin-top: 16px;
  }

  &-list {
    max-height: 40vh;
    overflow: auto;
    padding-right: 8px;
  }

  &-nodata {
    text-align: center;
    margin: 24px 0 8px;
  }

  &-item {
    margin-top: 8px;
    padding: 12px 16px;
    border-radius: var(--border-radius);
    background-color: var(--bg_surface) !important;
    cursor: pointer;

    &-header {
      display: flex;
      align-items: center;
    }

    &-main {
      display: flex;
      align-items: center;
    }

    &-name {
      .r-mid-text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 160px;
      }
    }

    &-type {
      margin-left: 8px;
    }

    &-time {
      margin-left: auto;
    }

    &-arrow {
      margin-left: 16px;

      i {
        color: var(--text_secondary) !important;
      }
    }

    &-additional {
      padding: 12px;
      padding-bottom: 0;
    }

    &-row {
      &:not(:first-child) {
        margin-top: 16px;
      }

      .r-block-title {
        margin-bottom: 4px;
      }
    }

    &-value {
      font-size: 12px;
      width: 100%;
      text-align: center;
      padding: 8px;
      border-radius: 4px;
      background-color: var(--modal_bg) !important;

      &.text {
        text-align: left;
        white-space: pre-line;
      }

      &.download {
        color: var(--accent_primary);

        &:hover {
          background-color: rgba(var(--accent_primary), 0.2) !important;
        }
        &:active {
          background-color: rgba(var(--accent_primary), 0.3) !important;
        }
      }

      &.controls {
        .r-button {
          width: 100%;
        }
      }
    }
  }

  &-row {
    display: flex;

    &:not(:first-child) {
      margin-top: 12px;
    }

    .r-select {
      width: 100%;
    }
  }

  &-due {
    margin-top: 16px;
  }

  &-block {
    flex: 1;

    &:not(:first-child) {
      margin-left: 16px;
    }

    .el-input-number {
      width: 100% !important;
    }
  }
}
</style>
